/** Tenant-side byte formatter — VISTOERA_TENANT_OVERVIEW_HOME_V1 §22.
 *
 * Same base-1024 KB/MB/GB/TB convention as the Platform Admin surface's
 * own `formatBytes` (`saas/platform/adminShared.tsx`) — kept as a
 * separate tenant-side copy rather than a cross-import so the Workspace
 * shell never depends on the Platform Admin bundle (the two surfaces are
 * deliberately independent — see `WorkspaceLayout`/`platform` module
 * boundaries elsewhere in this repo), while still guaranteeing the exact
 * same number renders the exact same way project-wide (spec: "全项目统一
 * 采用一个 convention").
 */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined || Number.isNaN(bytes)) return '—'
  if (bytes <= 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let value = bytes
  let unitIndex = 0
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024
    unitIndex += 1
  }
  return `${value.toFixed(unitIndex === 0 ? 0 : 2)} ${units[unitIndex]}`
}
